import type { NavItem } from "@/shared/components/layout/sidebar-nav.types";

export function resolveNavHref(to: string, workspaceSlug: string): string {
  return to.replace("$workspaceSlug", workspaceSlug);
}

export function navDestinations(item: NavItem): NavItem[] {
  if (item.children === undefined) {
    return item.to === "" ? [] : [item];
  }
  return item.children.filter((child) => child.heading !== true && child.to !== "");
}

export function pathMatches(pathname: string, to: string, workspaceSlug: string): boolean {
  if (to === "") return false;
  const href = resolveNavHref(to, workspaceSlug);
  if (pathname === href) return true;
  if (href === `/${workspaceSlug}`) return false;
  return pathname.startsWith(`${href}/`);
}

export function isNavItemActive(pathname: string, item: NavItem, workspaceSlug: string): boolean {
  if (item.children !== undefined) {
    return item.children.some((child) => pathMatches(pathname, child.to, workspaceSlug));
  }
  return pathMatches(pathname, item.to, workspaceSlug);
}

/** A sidebar row stays only when at least one destination is usable. */
export function isSidebarVisible(item: NavItem): boolean {
  if (item.heading === true) return false;
  return navDestinations(item).some((destination) => destination.locked !== true);
}

export function withRolledIndicators(item: NavItem): NavItem {
  if (item.children === undefined) return item;
  const newActivity = item.children.some((child) => child.newActivity === true);
  return newActivity ? { ...item, newActivity: true } : item;
}
